import { mobileWidth } from 'enum/responsive-width.enum'
import { useWindowSize } from './react.hooks'

export const useIsMobile = () => {
  const windowsSize = useWindowSize()
  const { width } = windowsSize
  return width ? width < mobileWidth : false
}
